<div id="main-wrapper" class="container" style="margin-top: 120px;">
    <div class="row justify-content-center">
        <div class="col-lg-5">
            <div class="card border 0" style="background: #f6f9fc;">
                <div class="card-body p-0">
                    <div class="row no-gutters">
                        <div>
                            <div class="p-5">
                                <div class="mb-5">
                                    <img src="assets/logo.png" alt="Image Alt Text" class="image" style="margin-left: 120px;width: 180px; height: 35px;">
                                </div>                             
                                <form [formGroup]="LoginDetails" (ngSubmit)="onsubmit()">
                                    <div class="form-group">
                                        <label for="exampleInputEmail1"><strong>Email ID</strong> </label>
                                        <input type="email" class="form-control" id="exampleInputEmail1" [formControl]="LoginDetails">
                                        <div *ngIf="LoginDetails.invalid && LoginDetails.touched" >
                                            <div *ngIf="LoginDetails.errors?.['required']" style="color: red;">Email ID is required.</div>
                                            <div *ngIf="LoginDetails.errors?.['email']" style="color: red;">Please enter a valid Email ID.</div>
                                          </div>
                                    </div>
                                    <!-- <br><br> -->
                                    <button type="submit" class="btn btn-theme" style="margin-top: 50px;"><strong>Login</strong></button>                         
                                </form>
                            </div>
                        </div>            
                    </div>

                </div>
                <!-- end card-body -->
            </div>
            <!-- end card -->
            <!-- end row -->
        </div>
        <!-- end col -->
    </div>
    <!-- Row -->
</div>

<p-dialog header="Alert" [(visible)]="alertVisible" [modal]="true" [style]="{width: '20vw'}">
    <p class="Pmessage">
        User does not exists in the system. Please contact application administrator.
    </p>
</p-dialog>